import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, spacing }) => ({
  badge: {
    width: 14,
    height: 14,
    borderRadius: 7,
    minWidth: 0,
    minHeight: 0,
    fontSize: 11,
    top: 4,
    right: 4,
    border: "1px solid",
    borderColor: palette.primary.main,
  },
  button: {
    color: palette.common.white,
    padding: 0,
    minHeight: 36,
    minWidth: 36,
  },
  list_item: {
    "& nth:last-child": {
      border: 0,
    },
    borderBottom: `solid 1px ${palette.grey["200"]}`,
    width: spacing(50),
  },
  popover_paper: {
    overflowX: "hidden",
    overflowY: "auto",
  },
  popover_root: {
    marginTop: 60,
  },
}));
